<div *ngIf="visibleDocuments; else noDataTmp" class="config-documents">
  <!-- Политика конфиденциальности ассоциации (ссылка) -->
  <app-download-link
    *ngIf="visiblePolicy"
    class="download-link"
    [fileLink]="appConfigData?.privacyPolicyLink"
    [isLocalFile]="false"
  >
    {{ 'components.policy.buttons.association' | translate : { value: appConfigData?.shortName ?? '' } }}
  </app-download-link>

  <app-download-link
    *ngFor="let document of documents"
    class="download-link"
    [fileLink]="basePathDocuments + document.fileName"
  >
    {{ document.displayName }}
  </app-download-link>
</div>

<ng-template #noDataTmp>
  <div *ngIf="showNoData" class="no-data">
    {{ 'components.configDocuments.labels.noDocuments' | translate }}
  </div>
</ng-template>
